import { createReducerFromMap, createAsyncReducer, createDefaultInitialState } from "@coverme/redux";
import { sortStatesByCustomerJurisdictions } from "../services/stateSorter";

const initialValues = createDefaultInitialState({
    configuration: {
        programSections: {
            government: undefined,
        },
    },
});

const getLookups = (state, action) => {
    const states = sortStatesByCustomerJurisdictions(action.value.lookups.states, action.value.customerJurisdictions);
    const typesOfCoverage = [...action.value.lookups.typeOfCoverage].sort((a, b) => {
        const textA = a.name.toUpperCase();
        const textB = b.name.toUpperCase();

        if (textA === "OTHER") {
            return 1;
        }

        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    const immigrationStatus = [...action.value.lookups.immigrationStatus].sort((a, b) => {
        const textA = a.toUpperCase();
        const textB = b.toUpperCase();
        if (textA === "NONE OF THESE") {
            return 1;
        }
        if (textB === "NONE OF THESE") {
            return -1;
        }
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    return {
        ...action.value.lookups,
        states: states,
        typeOfCoverage: typesOfCoverage,
        immigrationStatus,
    };
};

const getProgramSections = (state, action) => {
    return {
        ...state,
        configuration: {
            ...state.configuration,
            programSections: action.value,
        },
    };
};

export const lookupReducer = createReducerFromMap(initialValues, {
    ...createAsyncReducer("GET_LOOKUPS", getLookups),
    ...createAsyncReducer("GET_PROGRAM_SECTIONS", getProgramSections),
});
